import React from 'react'
import PDIComponent from '../pdi/PDIComponent'

export const GemiAracGiris = () => {
    return <PDIComponent depo={true}
        role_name={"gemi_tahliye_write"}
        title="Gemi Tahliye" radioItems={["Gemi Tahliye", "Hasar Bildir"]} defaultRadio="Gemi Tahliye" showSwitch={true} api="/processShipUnload" modalArea="Gemi Tahliye" />
}
